import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'

export const InformationBox = (props: {
	children: React.ReactNode
	className?: string
}) => {
	return (
		<div
			className={cn(
				'rounded-md border-[0.5px] border-background/10 bg-foreground/[.02] px-6 py-4 backdrop-brightness-200 dark:bg-background/30',
				props.className,
			)}
		>
			{props.children}
		</div>
	)
}
